import React, { useEffect } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as validationService from "../add-device-modal/validationService";

function MSTenantIdField({ value, onChange, error, disabled }) {

    useEffect(() => {
        validationService.validateNotEmpty(value, 'msTenantId');
        return () => validationService.cleanValidation('msTenantId');
    }, [value])


    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="ms_tenantid">Tenant Id <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="ms_tenantid-key"
                    disabled={disabled}
                    value={value}
                    onChange={disabled ? null : (event => onChange(event.target.value))} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("MSTenantIdField mapStateToProps", state);
    const validation = state.validation;
    return {       
        error: validation.msTenantId
    }
}

export default connect(mapStateToProps)(MSTenantIdField);
